import React from 'react'

export const PrivacyFaqView = () => (
  <div style={{"background-color": "#fff", "padding": "16px"}}>
    <p><strong>Cookies</strong></p>
    <p>
      Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent
      to your browser from the website that you visit and are stored on your computer’s hard drive.

      Our website uses these “cookies” to collection information and to improve our Service. You have the option to
      either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to
      refuse our cookies, you may not be able to use some portions of our Service.
    </p>
  </div>
)

export default PrivacyFaqView



// WEBPACK FOOTER //
// ./src/routes/PrivacyFaq/components/PrivacyFaqView.js